export default __webpack_public_path__ + "static/media/osm.7ec4df9f.png";